import Apps from "./Apps"
import Games from "./Games"
import AppsAndGames from "./AppsAndGames"
import useT from "utils/useT"
import { useEffect, useState } from "react"
import useRouterStore from "stores/routerStore"
import useFiltersStore from "stores/filters"
import Tabs from "components/Tabs"

const AppsPage = ({ query }: any) => {
  const t = useT()
  const asPath = useRouterStore((state) => state.router?.asPath)
  const switchParam = useRouterStore((state) => state.router?.query.switch)
  const priceParam = useRouterStore((state) => state.router?.query.price)
  const URLQuery = new URLSearchParams(asPath)?.entries()?.next()?.value?.[1]
  const type = query?.switch || URLQuery || switchParam || "all"
  const priceFilter = query?.price || priceParam
  const [page, setPage] = useState(type)
  const price = useFiltersStore((state) => state.price)
  const setPrice = useFiltersStore((state) => state.setPrice)

  useEffect(() => {
    priceFilter && setPrice(priceFilter)
  }, [priceFilter])

  return (
    <>
      <div className="card card-style">
        <div className="content" dir="auto">
          {t.apps.hero}
        </div>
      </div>
      <Tabs price={price} page={page} setPage={setPage} />
      {page === "apps" && <Apps />}
      {page === "games" && <Games />}
      {page === "all" && <AppsAndGames />}
    </>
  )
}
export default AppsPage
